import { Timestamp } from "firebase/firestore";

/**
 * Convert a Firestore Timestamp or serialised timestamp object → JS Date
 */
export const toDate = (ts) => {
  if (!ts) return null;
  if (ts instanceof Timestamp) return ts.toDate();
  // serialised shape: { type, seconds, nanoseconds }
  if (ts.seconds !== undefined) {
    return new Timestamp(ts.seconds, ts.nanoseconds ?? 0).toDate();
  }
  return new Date(ts);
};

/**
 * Return a Firestore server-compatible Timestamp for "now"
 */
export const nowTimestamp = () => Timestamp.now();

/**
 * Format a Firestore timestamp (or serialised object) to a human-readable string
 */
export const formatTimestamp = (ts, options = {}) => {
  const date = toDate(ts);
  if (!date) return "—";
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    ...options,
  });
};

/**
 * Format only the date portion
 */
export const formatDate = (ts) =>
  formatTimestamp(ts, { hour: undefined, minute: undefined });

/**
 * Build a serialised timestamp from a JS Date (for Redux-safe storage)
 */
export const toSerializedTimestamp = (date = new Date()) => ({
  type: "firestore/timestamp/1.0",
  seconds: Math.floor(date.getTime() / 1000),
  nanoseconds: 0,
});
